/*
  pickSpec is a helper function that lets you define a spec {k: v} and fill it with values
  from an object.
  Signature: {k: v} -> {k: v} -> {k: v}

  Examples:
    1) pickSpec({ foo: 1, bar: true }, { foo: 3 }) -> { foo: 3, bar: true }
    2) pickSpec({ name: '' }, { name: 'Joe', age: 17 }) -> { name: 'Joe' }
 */
import { curry, is, merge, filter, complement, isNil, pick, keys } from 'ramda';

export default curry((spec, obj) =>
  is(Object, spec) && is(Object, obj) ? merge(spec, filter(complement(isNil), pick(keys(spec), obj))) : spec,
);
